import dayjs, { ConfigType } from 'dayjs';
import { DurationUnitType } from 'dayjs/plugin/duration';

export const formatTimezoneSpecific = (
  date: ConfigType,
  timeZone?: string,
  template: string = 'L'
): string => {
  const isStringNumber = typeof date === 'string' && /^\d+$/.test(date);
  const dayjsValue = dayjs(isStringNumber ? Number(date) : date);

  return (timeZone ? dayjsValue.tz(timeZone) : dayjsValue).format(template);
};

export const getDuration = (
  start: number | dayjs.Dayjs,
  unit: DurationUnitType = 'second',
  finished?: number | dayjs.Dayjs
): number => {
  const startDate = dayjs(start);

  if (!finished) {
    return dayjs.duration(dayjs().diff(startDate)).as(unit);
  }

  const finishDate = dayjs(finished);
  const diff = finishDate.diff(dayjs());
  const durationValue = dayjs.duration(Math.max(diff, 0));

  return Math.floor(durationValue.as(unit));
};

export const formatDate = (date: ConfigType, format: string): string => {
  return dayjs(date).format(format);
};

export const formatDuration = (duration: number): string => {
  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
